import useSessionNotices, { LOGOUT_NOT_SAVED } from '@/components/common/authentication/useSessionNotices';
import { apiSdkAtom } from '@/context/atoms/ApiSdk';
import { AuthStoreError } from '@ekkogmbh/apisdk';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

/** Logs out in every tab, with WebEAM also at the identity provider. */
export default function useLogout(): () => Promise<void> {
  const api = useAtomValue(apiSdkAtom);
  const { notifyWarning } = useSessionNotices();

  return useCallback(async (): Promise<void> => {
    // The session is logged out everywhere before `logout()` settles. It
    // rejects with something else than `AuthStoreError` only when revoking
    // the token at WebEAM failed, which leaves nothing for the user to do.
    try {
      await api.session.logout();
    } catch (error) {
      if (error instanceof AuthStoreError) {
        notifyWarning(LOGOUT_NOT_SAVED);
      } else {
        console.error('Logging out failed:', error);
      }
    }
  }, [api, notifyWarning]);
}
